import { Button, Card, Group, Stack, Text, ThemeIcon } from 'ui';
import { CloseIcon } from 'ui/Icons';

import classes from './MyPersonalizedStartCard.module.css';
import { useOnboardingState } from './useOnboardingState';

const MyPersonalizedStartCard = () => {
  const { shouldShow, personalizedText, handleGetStarted, handleDismiss, isLoadingBacker } =
    useOnboardingState();

  if (!shouldShow || isLoadingBacker) {
    return null;
  }

  return (
    <Card className={classes.MyPersonalizedStartCard}>
      <Stack mt="16px" gap="8px">
        <Group justify="space-between">
          <Text fw={600}>Your Personalized Start</Text>
          <ThemeIcon size="sm" color="white" variant="transparent" onClick={handleDismiss}>
            <CloseIcon />
          </ThemeIcon>
        </Group>
        <Text size="xs" fw={400}>
          {personalizedText}
        </Text>
      </Stack>
      <Button size="sm" my="16px" onClick={handleGetStarted} fullWidth>
        Get Started
      </Button>
    </Card>
  );
};

export { MyPersonalizedStartCard };
